import { Heart, MessageCircle, Send, MoreHorizontal, Bookmark } from "lucide-react";

/**
 * Instagram + Facebook feed preview mockups.
 * All content driven by the `creative` prop so users see edits live.
 */
export function InstagramPreview({ creative, brand = "La tua attività" }) {
  return (
    <div className="w-full max-w-[360px] mx-auto rounded-[28px] bg-black shadow-[0_20px_60px_-20px_rgba(0,0,0,0.6)] border border-white/10 overflow-hidden font-[system-ui]" data-testid="instagram-preview">
      {/* Notch */}
      <div className="h-6 bg-black flex items-center justify-center">
        <div className="w-24 h-4 rounded-full bg-black" />
      </div>
      <div className="bg-white text-[#0F172A]">
        {/* Header */}
        <div className="flex items-center gap-2 px-3 py-2.5">
          <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-fuchsia-500 via-rose-500 to-amber-400 p-[2px]">
            <div className="w-full h-full rounded-full bg-white p-[2px]">
              <div className="w-full h-full rounded-full bg-gradient-to-br from-rose-400 to-amber-400" />
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[13px] font-semibold leading-tight truncate">{brand}</div>
            <div className="text-[10px] text-neutral-500 leading-tight">Sponsorizzato</div>
          </div>
          <MoreHorizontal size={16} className="text-neutral-700" />
        </div>
        {/* Image */}
        <div className="aspect-square w-full bg-neutral-100 relative overflow-hidden">
          {creative.image_url ? (
            <img src={creative.image_url} alt="" className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-neutral-400 text-sm">Immagine</div>
          )}
          {/* CTA sticker */}
          <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between rounded-lg bg-white/95 backdrop-blur px-3 py-2 shadow-sm">
            <div className="min-w-0">
              <div className="text-[10px] text-neutral-500 uppercase leading-tight">{creative.destination_url || "URL di destinazione da impostare"}</div>
              <div className="text-[12px] font-semibold text-neutral-900 truncate">{creative.headline}</div>
            </div>
            <button className="shrink-0 px-3 py-1 rounded-md bg-[#0095F6] text-white text-[11px] font-semibold uppercase tracking-wide">
              {creative.cta || "SCOPRI"}
            </button>
          </div>
        </div>
        {/* Actions */}
        <div className="px-3 pt-2 pb-1 flex items-center gap-4">
          <Heart size={22} className="text-neutral-800" strokeWidth={1.5} />
          <MessageCircle size={22} className="text-neutral-800" strokeWidth={1.5} />
          <Send size={22} className="text-neutral-800" strokeWidth={1.5} />
          <div className="ml-auto">
            <Bookmark size={22} className="text-neutral-800" strokeWidth={1.5} />
          </div>
        </div>
        <div className="px-3 pb-3 text-[12px] leading-snug">
          <span className="font-semibold">{brand}</span>{" "}
          <span className="text-neutral-800">{creative.primary_text}</span>
        </div>
      </div>
    </div>
  );
}

export function FacebookPreview({ creative, brand = "La tua attività" }) {
  return (
    <div className="w-full max-w-[420px] mx-auto rounded-2xl bg-white text-[#0F172A] shadow-[0_20px_60px_-20px_rgba(0,0,0,0.4)] overflow-hidden font-[system-ui]" data-testid="facebook-preview">
      {/* Header */}
      <div className="flex items-center gap-2 px-4 py-3">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-bold">
          {brand.charAt(0)}
        </div>
        <div className="flex-1">
          <div className="text-[14px] font-semibold text-neutral-900 leading-tight">{brand}</div>
          <div className="text-[11px] text-neutral-500">Sponsorizzato · <span className="align-middle">🌐</span></div>
        </div>
        <MoreHorizontal size={18} className="text-neutral-500" />
      </div>
      <div className="px-4 pb-3 text-[13.5px] leading-snug text-neutral-800">
        {creative.primary_text}
      </div>
      {/* Media */}
      {creative.image_url ? (
        <img src={creative.image_url} alt="" className="w-full aspect-[1.91/1] object-cover" />
      ) : (
        <div className="w-full aspect-[1.91/1] bg-neutral-100" />
      )}
      {/* CTA bar */}
      <div className="flex items-center justify-between px-4 py-3 bg-neutral-100">
        <div className="min-w-0">
          <div className="text-[10px] text-neutral-500 uppercase leading-tight">{creative.destination_url || "URL di destinazione da impostare"}</div>
          <div className="text-[15px] font-bold text-neutral-900 truncate">{creative.headline}</div>
        </div>
        <button className="shrink-0 px-4 py-2 rounded-md bg-[#1877F2] text-white text-[12px] font-bold uppercase">
          {creative.cta || "Scopri"}
        </button>
      </div>
    </div>
  );
}
